<template>
    <section class="mb-6">
        <h5 class="is-size-5">
            {{ title }}
            <b-tooltip v-if="description" :triggers="['click']" type="is-light" :auto-close="['outside', 'escape']" position="is-right">
                <!--<span class="gant-text pointer is-size-7">View details</span>-->
                <b-icon pack="mdi" icon="help-box" size="is-small" type="is-info" />
                <template #content>
                    <p><b>{{ description.intro }}</b></p>
                    <ul>
                        <li v-for="item in description.items" :key="item">{{ item }}</li>
                    </ul>
                </template>
            </b-tooltip>
        </h5>
        <div class="mt-4">
            <slot></slot>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        title: {
            defalut: '',
            type: String,
        },
        description: {
            default: null,
            type: Object,
        },
    },
};
</script>

<style scoped>
.pointer {
    cursor: pointer;
}
</style>
